import { z } from 'zod';
/**
 * Money on the wire.
 *
 * Postgres stores these as NUMERIC(19,4) and Prisma hands back a Decimal.
 * Serialising through a JS `number` would silently round at the 17th
 * significant digit, so the API emits a fixed-precision STRING and the client
 * formats it with Intl.NumberFormat. Never parse this with parseFloat before
 * doing arithmetic — do the arithmetic on the server.
 */
export const moneySchema = z.string().regex(/^-?\d+(\.\d{1,4})?$/, 'Expected a decimal amount');
/** ISO 4217, uppercase. */
export const currencyCodeSchema = z.string().length(3).toUpperCase();
/** ISO 3166-1 alpha-2, uppercase. */
export const countryCodeSchema = z.string().length(2).toUpperCase();
export const uuidSchema = z.string().uuid();
/** Timestamps cross the wire as ISO 8601 strings. */
export const isoDateTimeSchema = z.string().datetime();
/**
 * URL-safe slug: lowercase alphanumerics separated by single hyphens.
 * Used for Tenant.slug, Product.handle, App.handle, Theme.handle.
 */
export const handleSchema = z
    .string()
    .min(1)
    .max(255)
    .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, 'Expected a lowercase, hyphen-separated handle');
export const emailSchema = z.string().email().toLowerCase();
//# sourceMappingURL=primitives.js.map